<template>
  <v-container grid-list-lg fluid class="subscription-form-page">
    <v-layout column class="subscription-form-layout">
      <v-flex>
        <v-card elevation="0" class="subscription-form-card mt-0">
          <v-toolbar flat class="subscription-form-header">
            <div>
              <div class="subscription-form-eyebrow">Billing</div>
              <v-toolbar-title>New subscription template</v-toolbar-title>
              <div class="subscription-form-subtitle">Set the billing schedule, account, and recurring line items.</div>
            </div>
            <v-spacer> </v-spacer>
            <v-row justify="end" class="subscription-form-header__actions">
              <v-col class="shrink">
                <v-btn color="primary" depressed :loading="loadingSaveBtn" :disabled="disabled" @click="continueSaving">{{
                  subscriptionTotal | currency
                  }} Save</v-btn>
              </v-col>

              <v-col class="shrink">
                <v-btn text @click.stop.prevent="cancel">Cancel</v-btn>
              </v-col>
            </v-row>
          </v-toolbar>
          <v-card-text class="subscription-form-body">
            <div class="subscription-section-title">Subscriber</div>
            <v-layout row wrap class="subscription-form-grid">
              <v-flex xs12 md3>
                <v-select outlined rounded dense :items="['Donor', 'Parent']" v-model="templateType"
                  label="Select Type"></v-select>
              </v-flex>
              <v-flex xs12 md9 v-if="templateType === 'Donor'">
                <DonorsAutoComplete v-model="selectedCustomer" label="Select Donor" @reset="$emit('reset')"
                  :initValue="initValue" :errorMessages="selectCustomerError" />
              </v-flex>
              <v-flex xs12 md9 v-else>
                <ParentAutoComplete label="Select Parent" v-model="selectedCustomer" @reset="$emit('reset')"
                  :initValue="initValue" :errorMessages="selectCustomerError" />
              </v-flex>
            </v-layout>
            <div class="subscription-section-title subscription-section-title--spaced">Schedule</div>
            <v-layout row wrap class="subscription-schedule-grid">
              <v-flex shrink md2>
                <v-select hide-details outlined dense :items="['Monthly', 'Yearly']" v-model="interval"
                  label="Interval"></v-select>
              </v-flex>
              <v-flex v-if="interval === 'Monthly'" shrink>
                <v-layout row align-center>
                  <v-flex shrink>
                    on
                  </v-flex>
                  <v-flex shrink>
                    <v-select hide-details outlined dense item-text="name" :items="Days" return-object
                      v-model="selectedDay" label="Day"></v-select>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex v-else shrink>
                <v-layout row align-center>
                  <v-flex shrink>
                    every
                  </v-flex>
                  <v-flex shrink>
                    <v-select hide-details outlined dense item-text="name" return-object :items="Months"
                      v-model="selectedMonth" label="Month"></v-select>
                  </v-flex>
                  <v-flex shrink>
                    <v-select hide-details outlined dense item-text="name" :items="Days" return-object
                      v-model="selectedDay" label="Day"></v-select>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex shrink>
                <v-layout row align-center>
                  <v-flex shrink>
                    <DateSelector label="Start Date" v-model="startingDate" :notClearable="true" />
                  </v-flex>
                  <v-flex shrink>
                    <v-select hide-details outlined dense :items="['Forever', 'By', 'Cycle']" v-model="end"
                      label="End"></v-select>
                  </v-flex>
                  <v-flex shrink v-if="end === 'By'">
                    <DateSelector label="End Date" :initValue="endDateInit" v-model="endDate" :notClearable="true" />
                  </v-flex>
                  <v-flex shrink v-if="end === 'Cycle'">
                    <v-text-field type="number" outlined dense hide-details v-model="cycle"
                      label="Cycle"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

            <p class="subscription-schedule-summary">Invoice will be created <span class="font-weight-bold">{{ interval }}</span> on
              the <span class="font-weight-bold" v-if="selectedDay.value !== 'last'">{{ selectedDay.name }}</span> <span
                v-else class="font-weight-bold">{{ selectedDay.name }} Day </span>
              of every <span v-if="selectedMonth" class="font-weight-bold">{{ selectedMonth.name }}</span>
              <span v-else>month,</span> starting <span class="font-weight-bold">{{ Subscription.startingDate |
                moment("L")
                }}</span> <span v-if="end !== 'Forever'"> and will cancel on
                <span class="font-weight-bold">{{ endDate | moment("L") }}</span>.</span>
              <span v-else class="font-weight-bold red--text">until cancel.</span> First Invoice will be created
              on <span class="font-weight-bold">{{ Subscription.nextInvoiceDate | moment("L") }}</span>
            </p>
            <v-layout row wrap align-center class="subscription-options">
              <v-flex>
                <v-checkbox
                    label="Cash Collect"
                    hide-details
                    outlined
                    dense
                    v-model="cashCollect"
                  ></v-checkbox>
              </v-flex>
            </v-layout>
            <v-layout row wrap align-center class="subscription-form-actions">
              <v-flex v-if="isCustomer">
                <v-btn color="primary" outlined @click="addCurrentStudents"><v-icon left>mdi-account-multiple-plus-outline</v-icon>Add current students</v-btn>
              </v-flex>

              <v-flex shrink>
                <v-select dense outlined :items="MerchantAccount" hide-details v-model="selectedMerchant" return-object
                  item-text="name" label="Select Default Account"></v-select>
              </v-flex>
              <!-- <v-flex>
              <v-select item-text="last4" return-object v-model="selectedCard" :loading="loadingCard" outlined dense
                hide-details :items="cards" label="Payment Method">
                <template slot="item" slot-scope="{ item }">
                  <span>{{ item.last4 }}</span>
                  <v-spacer></v-spacer>
                  <span class="text-capitalize">{{ item.payment_method_type
                  }}</span>
                </template>
</v-select>
</v-flex> -->
            </v-layout>



          </v-card-text>


        </v-card>
      </v-flex>
      <v-flex>
        <ProductSearchBar @submit="addRow" :customerID="selectedCustomer" />
      </v-flex>
      <v-flex>
        <Cart />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import studentService from "@/modules/Student/service.js";
import subscriptionService from "@/modules/Subscription/service.js";
import donorService from "@/modules/Donors/service.js";
import customerService from "@/modules/Customer/service.js";
import ProductSearchBar from "@/modules/Subscription/components/ProductSearchBar";
// import orderService from "@/modules/Order/InHouse/service";
import Cart from "@/modules/Subscription/components/Cart";
import DateSelector from "@/components/DateSelector";
import productService from "@/modules/Product/service.js";
// import payCompassService from "@/modules/PayCompass/service.js";
import donationCategoryService from "@/modules/DonationCategory/service.js";
import DonorsAutoComplete from "@/modules/Donors/components/AutoComplete.vue";
import ParentAutoComplete from "@/modules/Customer/components/AutoComplete.vue";
// import CustomerSection from "@/modules/Subscription/components/CustomerSection.vue";
import { mapActions, mapGetters } from "vuex";
// import Hashids from "hashids";
// const hashids = new Hashids();

export default {
  name: "create-subscription-invoice",
  // props: {
  //   studentSub: {
  //     default: false,
  //   }
  // },
  data() {
    return {
      selectedMerchant: null,
      MerchantAccount: [],
      studentSub: false,
      loadingCard: false,
      isCustomer: false,
      cashCollect: false,
      cards: [],
      autoSelectedType: "donor",
      order: null,
      loadingSaveBtn: false,
      loading: true,
      selectCustomerError: [],
      initValue: null,
      selectedMonth: { name: 'January', value: 1 },
      end: 'Forever',
      selectedDay: { name: '1st', value: 1 },
      interval: 'Monthly',
      templateType: 'Parent',
      editDialog: false,
      setCustomer: null,
      endDate: null,
      endDateInit: new Date().toISOString(),
      cycle: null,
      initDueDate: null,
      startingDate: new Date().toISOString(),
      // selectedCard: null,
      Months: [
        { name: 'January', value: 1 },
        { name: 'February', value: 2 },
        { name: 'March', value: 3 },
        { name: 'April', value: 4 },
        { name: 'May', value: 5 },
        { name: 'June', value: 6 },
        { name: 'July', value: 7 },
        { name: 'August', value: 8 },
        { name: 'September', value: 9 },
        { name: 'October', value: 10 },
        { name: 'November', value: 11 },
        { name: 'December', value: 12 }
      ],
      Days: [
        { name: '1st', value: 1 },
        { name: '2nd', value: 2 },
        { name: '3rd', value: 3 },
        { name: '4th', value: 4 },
        { name: '5th', value: 5 },
        { name: '6th', value: 6 },
        { name: '7th', value: 7 },
        { name: '8th', value: 8 },
        { name: '9th', value: 9 },
        { name: '10th', value: 10 },
        { name: '11th', value: 11 },
        { name: '12th', value: 12 },
        { name: '13th', value: 13 },
        { name: '14th', value: 14 },
        { name: '15th', value: 15 },
        { name: '16th', value: 16 },
        { name: '17th', value: 17 },
        { name: '18th', value: 18 },
        { name: '19th', value: 19 },
        { name: '20th', value: 20 },
        { name: '21st', value: 21 },
        { name: '22nd', value: 22 },
        { name: '23rd', value: 23 },
        { name: '24th', value: 24 },
        { name: '25th', value: 25 },
        { name: '26th', value: 26 },
        { name: '27th', value: 27 },
        { name: '28th', value: 28 },
        { name: 'Last', value: 'last' },
      ]
    };
  },
  components: {
    Cart,
    DonorsAutoComplete,
    DateSelector,
    ParentAutoComplete,
    ProductSearchBar,
  },
  watch: {
    // selectedCustomer(val) {
    //   if (val?.payCompassId) {
    //     this.getCard(val.payCompassId)
    //   }
    // },
    cycle() {
      this.setEndDate()
    },
    startingDate() {
      this.setEndDate()
    },
    selectedDay() {
      this.setEndDate()
    },
    selectedMonth() {
      this.setEndDate()
    },
    interval: {
      handler(val) {
        if (val === 'Monthly') {
          this.selectedMonth = null
          this.setEndDate()
        } else {
          this.selectedMonth = { name: 'January', value: 1 }
          this.setEndDate()
        }
      },
      deep: true, // Watch for changes within the object
      immediate: true // This option triggers the watch immediately
    },
    end() {
      // console.log('end', val)
      this.setEndDate()
    }
  },
  async created() {
    // console.log('this.$route.query', this.$route.query)

    if (this.$route.query && this.$route.query.DonorId) {
      this.isCustomer = false
      this.templateType = "Donor"
      const donor = await donorService.getById(
        this.$route.query.DonorId
      );

      this.initValue = donor.data;
    }

    if (this.$route.query && this.$route.query.CustomerId) {
      this.isCustomer = true
      const customer = await customerService.getById(
        this.$route.query.CustomerId
      );
      // console.log('customer', customer)
      this.initValue = customer.data;
    }

    let currentDate = this.$moment(this.startingDate);
    let dayValue = currentDate.date();

    this.Days.map(day => {
      if (day.value === dayValue) {
        this.selectedDay = day
      }
    })
    if (!this.isCustomer) {
      this.end = 'Cycle'
      this.cycle = 12
    }
    this.getDonationCategoryList()
  },
  computed: {
    ...mapGetters("global", [
      "currentBusiness",
    ]),
    ...mapGetters("subscription", [
      "Subscription",
      "SubscriptionDetails",
      "subscriptionTotal",
      "getSelectedCustomer",
      "getSelectedCampaign",
    ]),
    selectedCampaign: {
      get: function () {
        return this.getSelectedCampaign;
      },
      set: function (val) {
        this.SetSelectedCampaign(val);
      },
    },
    disabled() {
      let value = true;
      value = this.SubscriptionDetails.length === 0;

      if (this.Subscription.studentSub) {
        value = false
      }
      return value;
    },
    selectedCustomer: {
      get: function () {
        return this.getSelectedCustomer;
      },
      set: function (val) {
        this.SetSelectedCustomer(val);
      },
    },
  },
  methods: {
    ...mapActions("subscription", [
      "AddSubscriptionDetail",
      "ResetSubscriptionDetail",
      "ResetSubscription",
      "SetEditSubscriptionId",
      "SetSelectedCustomer",
      "SetSelectedCampaign",
    ]),
    getDonationCategoryList() {
      return donationCategoryService.getAll().then((response) => {
        console.log('response merchant', response)
        this.MerchantAccount = response.data;
        this.MerchantAccount.map(row => {
          if (row.id === this.currentBusiness.DefaultSchoolFeeId) {
            // console.log('row selectedMerchant', row)
            this.selectedMerchant = row
          }
        })
      });
    },
    async addCurrentStudents() {
      // console.log('this.selectedCustomer', this.selectedCustomer)
      // console.log('this.currentBusiness', this.currentBusiness)
      let students = (await studentService.getAll({ CustomerId: this.selectedCustomer.id })).data
      // console.log('students', this.students)

      let product = null
      const business = this.currentBusiness

      if (business && business.metadata && business.metadata.defaultProduct && business.metadata.defaultProduct.id) {
        product = (await productService.getById(business.metadata.defaultProduct.id)).data
        console.log('product', product)
        if (!product) {
          return false;
        }
      } else {
        return false;
      }


      if (students.length !== 0) {
        this.ResetSubscriptionDetail()
        for (var i = 0; i < students.length; i++) {
          let student = students[i]
          console.log('student', student.ClassStudents.length)
          if (student.ClassStudents.length) {
            student.ClassStudents.map(row => {
              let studentRow = {
                name: `${product.name} - Parent Pay: ${row.parentPay} (${student.fullName})`,
                price: row.parentPay + row.charity,
                qty: 1,
                parentPay: row.parentPay,
                BusinessId: business.id,
                ProductId: product.id,
                StudentId: student.id,
                ClassRoomId: row.ClassRoomId,
                ClassId: row.Class.id,
                description: row.Class.name,
              }
              this.AddSubscriptionDetail(studentRow)
            })
          }
        }
        this.Subscription.studentSub = true;
      }
    },
    // getCard(id) {
    //   payCompassService.getAllCard(id).then(response => {
    //     console.log('response getAllCard', response)
    //     this.cards = response.data
    //     if (this.cards.length === 1) {
    //       this.selectedCard = this.cards[0]
    //     }
    //   })
    // },
    setEndDate() {
      if (this.interval === "Monthly") {
        if (this.end === 'By') {
          const endDate = this.$moment(this.startingDate).add(1, 'months');
          this.endDateInit = endDate.toISOString()
          this.Subscription.endDate = this.endDate
          this.Subscription.recurringForever = false
          this.nextInvoiceDate()
        } else if (this.end === 'Cycle') {
          this.Subscription.recurringForever = false
          const startingDate = this.$moment(this.startingDate).add(1, 'months')
          const endDate = startingDate.clone().add(this.cycle, 'months');
          this.endDateInit = endDate.toISOString()
          this.endDate = this.endDateInit
          this.Subscription.endDate = this.endDate
          this.nextInvoiceDate()
        } else {
          this.Subscription.recurringForever = true;
          this.endDateInit = null
          this.endDate = this.endDateInit
          this.Subscription.endDate = null
          this.nextInvoiceDate()
        }
      } else {
        if (this.end === 'By') {
          const endDate = this.$moment(this.startingDate).add(1, 'years');
          this.endDateInit = endDate.toISOString();
          this.endDate = this.endDateInit;
          this.Subscription.endDate = this.endDate;
          this.Subscription.recurringForever = false;
          this.nextInvoiceDate();
        } else if (this.end === 'Cycle') {
          const startingDate = this.$moment(this.startingDate);
          const endDate = startingDate.clone().add(this.cycle, 'years');

          this.endDateInit = endDate.toISOString();
          this.endDate = this.endDateInit;
          this.Subscription.endDate = this.endDate;
          this.Subscription.recurringForever = false;
          this.nextInvoiceDate();
        } else {
          this.endDateInit = null;
          this.endDate = this.endDateInit;
          this.Subscription.endDate = null;
          this.Subscription.recurringForever = true;
          this.nextInvoiceDate();
        }
      }
    },
    nextInvoiceDate() {
      const startingDate = this.$moment(this.startingDate);
      let nextInvoiceDate = null;

      if (this.interval === "Yearly") {
        nextInvoiceDate = startingDate.clone().date(this.selectedDay.value).month(this.selectedMonth.value);
      } else {
        nextInvoiceDate = startingDate.clone().date(this.selectedDay.value);
      }

      if (nextInvoiceDate.isSameOrBefore(startingDate)) {
        if (this.interval === "Yearly") {
          nextInvoiceDate.add(1, 'years');
        } else {
          nextInvoiceDate.add(1, 'months');
        }
      }

      if (this.selectedDay.value === 'last') {
        nextInvoiceDate.endOf('month');
      }

      this.Subscription.endDate = this.endDate;

      // Convert the date to UTC before saving
      const dateNoTime = nextInvoiceDate.startOf('day').utc();
      const isoString = dateNoTime.format('YYYY-MM-DD');
      this.Subscription.nextInvoiceDate = isoString;
    },
    cancel() {
      if (this.SubscriptionDetails.length > 0) {
        this.$swal({
          title: "Are you sure?",
          text: "You want to cancel this invoice",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#B71C1C",
          cancelButtonColor: "#43A047",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        }).then((result) => {
          if (result.value) {
            this.ResetSubscription();
            this.$router.go(-1);
          }
        });
      } else {
        this.ResetSubscription();
        this.$router.go(-1);
      }
    },
    continueSaving() {
      console.log('invoice', this.Subscription)
      console.log('ere', this.selectedCustomer)
      this.Subscription.cashCollect = this.cashCollect
      if (this.isCustomer) {
        this.Subscription.CustomerId = this.selectedCustomer.id
        this.Subscription.DefaultDonationCategoryId = this.selectedMerchant.id
        if (!this.Subscription.CustomerId) {
          this.selectCustomerError = [];
          this.selectCustomerError.push("Please Select Parent");
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "error",
              title: "Parent is not selected!",
            });
          return false;
        } else {
          // this.Subscription.DonorId = this.sele
          // console.log('ere', this.selectedCustomer)
        }
      } else {
        this.Subscription.DonorId = this.selectedCustomer.id
        if (!this.Subscription.DonorId) {
          this.selectCustomerError = [];
          this.selectCustomerError.push("Please Select Donor");
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "error",
              title: "Donor is not selected!",
            });
          return false;
        }
      }

      if (this.SubscriptionDetails) {
        var filterInvoiceDetail = this.SubscriptionDetails.filter(function (item) {
          if (!item.delete) {
            return item;
          }
        });

        // this.loadingSaveBtn = true;

        this.Subscription.intervalType = this.interval.toLowerCase()
        this.Subscription.startingDate = this.startingDate
        this.Subscription.intervalDays = this.selectedDay.value
        if (this.selectedMonth) {
          this.Subscription.intervalMonth = this.selectedMonth.value
        }
        this.Subscription.endDate = this.endDate
        this.Subscription.recurringCount = this.cycle
        if (this.selectedCard) {
          this.Subscription.paymentMethodId = this.selectedCard.id
        }


        // console.log('endDate', this.endDate)
        // console.log('startingDate', this.startingDate)
        let saveInvoice = this.Subscription;
        // console.log('saveInvoicesaveInvoice', saveInvoice)
        if (this.getSelectedCampaign) {
          saveInvoice.CampaignId = this.getSelectedCampaign.id
        }

        saveInvoice.SubscriptionDetails = filterInvoiceDetail;


        return subscriptionService
          .create(saveInvoice)
          .then(() => {
            const customerId = this.Subscription.CustomerId;
            this.ResetSubscription();
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "success",
                title: "Subscription was created!",
              });
            this.loadingSaveBtn = false;
            if (customerId) {
              this.$router.push({
                name: "customer-profile",
                params: { id: customerId, tab: 5 },
              });
            } else {
              this.$router.go(-1);
            }
          })
          .catch((error) => {
            console.log("error creating invoice", error);
            this.loadingSaveBtn = false;
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 6000,
              })
              .fire({
                icon: "error",
                title: error.data.message,
              });
          });
      }
    },
    addRow(val) {
      if (val) {
        this.AddSubscriptionDetail({
          ProductId: val.id,
          name: val.Bar.name,
          price: val.Bar.price,
          total: val.Bar.price * val.Bar.qty,
          qty: val.Bar.qty,
          cost: val.cost | 0,
          // imeiNumber: val.imeiNumber,
          previousPrice: val.Bar.price,
        });
      }
    },
  },
};
</script>

<style scoped>
.subscription-form-page {
  min-height: 100%;
  padding: 30px 36px 48px;
  background: #f6f8f6;
}

.subscription-form-layout {
  max-width: 1500px;
  margin: 0 auto;
}

.subscription-form-layout > .flex + .flex {
  margin-top: 14px;
}

.subscription-form-card,
.subscription-form-page >>> .v-card {
  overflow: hidden;
  border: 1px solid #e3e9e3;
  border-radius: 13px !important;
  box-shadow: none !important;
}

.subscription-form-header {
  height: 108px !important;
  min-height: 108px;
  padding: 0 24px;
  background: #fff !important;
  border-bottom: 1px solid #e8ede8;
}

.subscription-form-header >>> .v-toolbar__content {
  height: 108px !important;
}

.subscription-form-eyebrow {
  margin-bottom: 3px;
  color: #43a047;
  font-size: 10px;
  font-weight: 750;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.subscription-form-header .v-toolbar__title {
  color: #172033;
  font-size: 23px;
  font-weight: 750;
  letter-spacing: -0.02em;
}

.subscription-form-subtitle {
  margin-top: 2px;
  color: #728095;
  font-size: 12px;
}

.subscription-form-header__actions {
  flex: 0 0 auto;
  margin: 0;
}

.subscription-form-header__actions .col {
  padding: 6px;
}

.subscription-form-header__actions .v-btn,
.subscription-form-actions .v-btn,
.subscription-form-page >>> .v-btn {
  border-radius: 9px;
  text-transform: none;
  letter-spacing: 0;
}

.subscription-form-body {
  padding: 24px !important;
}

.subscription-section-title {
  margin-bottom: 12px;
  color: #253047;
  font-size: 13px;
  font-weight: 750;
}

.subscription-section-title--spaced {
  margin-top: 6px;
}

.subscription-form-grid,
.subscription-schedule-grid,
.subscription-options,
.subscription-form-actions {
  margin: -8px;
}

.subscription-form-grid > .flex,
.subscription-schedule-grid > .flex,
.subscription-options > .flex,
.subscription-form-actions > .flex {
  padding: 8px;
}

.subscription-schedule-summary {
  margin: 14px 0 8px;
  padding: 13px 15px;
  color: #536253;
  border: 1px solid #dce8dc;
  border-radius: 9px;
  background: #f4faf4;
  font-size: 13px;
  line-height: 1.55;
}

.subscription-options {
  min-height: 48px;
}

.subscription-form-actions {
  justify-content: space-between;
  border-top: 1px solid #edf1ed;
  margin-top: 6px;
  padding-top: 12px;
}

.subscription-form-page >>> .v-card__text {
  padding: 20px 24px;
}

.subscription-form-page >>> .v-input__slot {
  border-radius: 8px;
}

.subscription-form-page >>> .v-data-table-header th {
  color: #687568 !important;
  font-size: 11px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.subscription-form-page >>> .v-data-table tbody td {
  border-color: #edf1ed !important;
}

@media (max-width: 960px) {
  .subscription-form-page {
    padding: 20px 16px 36px;
  }

  .subscription-form-header {
    height: auto !important;
    min-height: 132px;
    padding: 16px;
  }

  .subscription-form-header >>> .v-toolbar__content {
    flex-wrap: wrap;
    height: auto !important;
    padding: 0;
  }

  .subscription-form-header__actions {
    width: 100%;
    justify-content: flex-end;
  }

  .subscription-form-body,
  .subscription-form-page >>> .v-card__text {
    padding: 16px !important;
  }
}

@media (max-width: 600px) {
  .subscription-form-page {
    padding: 12px 8px 28px;
  }

  .subscription-form-header .v-toolbar__title {
    font-size: 20px;
  }
}
</style>
